import React from "react";
import ArticleSearchContainer from "../../../containers/ArticleSearchContainer";

function PortalPCSidebarKeywordForm() {
  const { word, setWord, search } = ArticleSearchContainer.useContainer();

  return (
    <form
      className="portalPcSidebarKeyword"
      onSubmit={(e) => {
        e.preventDefault();
        search();
      }}
    >
      <span className="portalPcSidebarKeywordInput">
        <i className="fa fa-search" aria-hidden="true" />
        <input
          type="text"
          aria-label="キーワードで検索"
          placeholder="キーワードで検索"
          value={word}
          onChange={(e) => setWord(e.target.value)}
        />
      </span>
      <button type="submit" className="portalPcSidebarKeywordBtn">
        検索
      </button>
    </form>
  );
}

export default PortalPCSidebarKeywordForm;
